import { StorageEnum } from 'utils/StorageEnum';

export class CtTokenRepository {
  /**
   * @param {ctTokenModel.type} ctToken
   */
  static persist(ctToken) {
    localStorage.setItem(StorageEnum.CT_TOKEN, ctToken.ctToken);
  }

  /**
   * @return {string|null}
   */
  static fetch() {
    return localStorage.getItem(StorageEnum.CT_TOKEN);
  }

  static delete() {
    localStorage.removeItem(StorageEnum.CT_TOKEN);
  }
}

export class ctRefreshTokenRepository {
  /**
   * @param {ctTokenModel.type} ctToken
   */
  static persist(ctToken) {
    localStorage.setItem(StorageEnum.CT_REFRESH_TOKEN, ctToken.refreshToken);
  }

  /**
   * @return {string|null}
   */
  static fetch() {
    return localStorage.getItem(StorageEnum.CT_REFRESH_TOKEN);
  }

  static delete() {
    localStorage.removeItem(StorageEnum.CT_REFRESH_TOKEN);
  }
}
